<!-- avm-calculator-form.component.html -->

@if(loader){<app-loader></app-loader>}
@else{<div style="height: 4px;"></div>}
<div class="request-editor__main">
    <div class="d-flex align-items-center w-100">
        <button class="get">GET</button>
        <input [(ngModel)]="api_end_point" disabled [ngModelOptions]="{standalone: true}" type="text"
            placeholder="Enter URL or paste text" class="form-control">
    </div>
    <button type="submit" (click)="onSubmit()" [disabled]="loader" class="send">Send</button>
</div>
<div class="d-flex align-items-center w-100 nav-btn">
    <button [class.active]="selected_view == 'Params'" (click)="changeSelection('Params')">
        <h3 class="f-w-500">Input Parameter</h3>
    </button>
    <button [class.active]="selected_view == 'Response'" (click)="changeSelection('Response')">
        <h3 class="f-w-500">Response</h3>
    </button>
</div>

@if(selected_view == 'Params'){
<form [formGroup]="form">
    <div>
        <div class="api-ui">
            <div class="d-flex align-items-center mb-2 headers gap-05">
                <label>City Code <span class="danger">*</span></label>
                <input [(ngModel)]="city_code" [ngModelOptions]="{standalone: true}" type="text" class="form-control" />
            </div>
        </div>
    </div>
    <div>
        <div class="parameter-list row">
            <div class="col-lg-6">
                <div class="grouping filter-body">
                    <div class="api-ui">
                        <div class="d-flex align-items-center mb-2">
                            <label>Property UID <span class="danger">*</span></label>
                            <input [formControlName]="'property_uid'" type="text" (keyup)="onChange()"
                                class="form-control" />
                        </div>                     
                       
                        <div class="d-flex align-items-center mb-2">
                            <label>Land Area (in sqm) </label>
                            <input [formControlName]="'land_area'" type="number" (keyup)="onChange()"
                                class="form-control" />

                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <label>Builtup Area (in sqm) </label>
                            <input [formControlName]="'built_area'" type="number" (keyup)="onChange()"
                                class="form-control" />

                        </div>
                        
                        <div class="d-flex align-items-center mb-2">
                            <label>Floor</label>
                            <mat-select [formControlName]="'floor'" (selectionChange)="onChange()" class="form-control"
                                style="border: 1px solid #ccc; padding: 8px;">
                                <mat-option *ngFor="let option of floorOptions"
                                    [value]="option.value">{{option.label}}</mat-option>
                            </mat-select>
                        </div>
                           <div class="d-flex align-items-center mb-2">
                            <label>Type of Property</label>
                            <mat-select [formControlName]="'type'" (selectionChange)="onChange()"
                                class="form-control" style="border: 1px solid #ccc; padding: 8px;">
                                <mat-option *ngFor="let option of houseTypeOptions"
                                    [value]="option.value">{{option.label}}</mat-option>
                            </mat-select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="grouping filter-body">
                    <div class="api-ui">
                         <div class="d-flex align-items-center mb-2">
                            <label>Building Age</label>
                            <mat-select [formControlName]="'building_age'" (selectionChange)="onChange()"
                                class="form-control" style="border: 1px solid #ccc; padding: 8px;">
                                <mat-option *ngFor="let option of buildingAgeOptions"
                                    [value]="option.value">{{option.label}}</mat-option>
                            </mat-select>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <label>Finish Quality</label>
                            <mat-select [formControlName]="'finish_quality'" (selectionChange)="onChange()"
                                class="form-control" style="border: 1px solid #ccc; padding: 8px;">
                                <mat-option *ngFor="let option of finishQualityOptions"
                                    [value]="option.value">{{option.label}}</mat-option>
                            </mat-select>
                        </div>
                      

                        <div class="d-flex align-items-center mb-2">
                            <label>Basement</label>
                            <mat-select [formControlName]="'basement'"
                                (selectionChange)="onBasementChange($event.value)" class="form-control"
                                style="border: 1px solid #ccc; padding: 8px;">
                                <mat-option *ngFor="let option of basementOptions"
                                    [value]="option.value">{{option.label}}</mat-option>
                            </mat-select>
                        </div>
                      
                        <div class="d-flex align-items-center mb-2">
                            <label>Basement Uses</label>
                            <mat-select [formControlName]="'basement_uses'" (selectionChange)="onChange()"
                                class="form-control" style="border: 1px solid #ccc; padding: 8px;">
                                <mat-option *ngFor="let option of basementUsesOptions"
                                    [value]="option.value">{{option.label}}</mat-option>
                            </mat-select>
                        </div>
                       
                        <div class="d-flex align-items-center mb-2">
                            <label>Shaded Parking</label>
                            <input [formControlName]="'shaded_parking'" type="number" (keyup)="onChange()"
                                class="form-control" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
}

@if(selected_view == 'Response'){
@if (response) {
<div class="value-table-container">
    <table class="value-table">
        <tr class="value-row">
            <td class="label-col">Land Value</td>
            <td class="value-col min-value">{{response?.land_price.sale_price_min ? (response?.land_price.sale_price_min | number : "1.0-1"):'-'}}</td>
            <td class="connector-col">To</td>
            <td class="value-col max-value">{{response?.land_price.sale_price_max ? (response?.land_price.sale_price_max | number : "1.0-1"):'-'}}</td>
        </tr>
        <tr class="value-row">
            <td class="label-col">Built-up Value</td>
            <td class="value-col min-value">{{response?.properties_price.sale_price_min ? (response?.properties_price.sale_price_min | number : "1.0-1"):'-'}}</td>
            <td class="connector-col">To</td>
            <td class="value-col max-value">{{response?.properties_price.sale_price_max ? (response?.properties_price.sale_price_max | number : "1.0-1"):'-'}}</td>
        </tr>
        <tr class="total-row">
            <td class="label-col">Total</td>
            <td class="value-col min-value">{{response?.total.sale_price_min ? (response?.total.sale_price_min | number : "1.0-1") :'-'}}</td>
            <td class="connector-col">To</td>
            <td class="value-col max-value">{{response?.total.sale_price_max ? (response?.total.sale_price_max | number : "1.0-1"):'-'}}</td>
        </tr>
    </table>
</div>
} @else {
@if(is_requested){
<div class="text-center">No results found</div>
}
}
<div class="response row">
    <div class="col-lg-12">
        @if (api_Response) {
        <div class="est-js-code">
            <pre><code>{{api_Response | json}}</code></pre>
        </div>
        }
    </div>
</div>
}